import { useEffect, useRef, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import {
  DEBOUNCE_DELAY,
  initialMetaForTable,
  expense_request_status,
} from "constants/common";
import SelectComponent from "components/common/select";
import AsyncSelect from "components/common/select/AsyncSelect";
import { getCounties, getHealthPlans, getStates } from "containers/policies/api";
import debounce from "lodash/debounce";
import { useDebouncedCountiesDataCallback, useDebouncedHealthPlansDataCallback, useDebouncedStatesDataCallback } from "utils/debouncedHelper";
import { capitalizeName, sortData } from "utils/common";

const HousingExpenseRequestFilter = ({
  handleSubmittion,
  handleClose,
  currentFilters,
}) => {
  const [countiesList, setCountiesList] = useState([]);
  const debouncedFetchCountiesData = useDebouncedCountiesDataCallback();
  const [healthPlansList, setHealthPlansList] = useState([]);
  const [states, setStates] = useState([])
  const fetchHealthPlan = async (searchString) => {
    const result = await getHealthPlans({
      ...initialMetaForTable,
      search: searchString,
    });

    if (result["health_plans"]) {
      const data = result?.health_plans;
      setHealthPlansList(sortData(data));
    }
  };

  useEffect(() => {
    fetchHealthPlan();
  }, []);

  const debouncedHealthPlansDataCallback = useDebouncedHealthPlansDataCallback();
  const debounceStatesDataCallBack = useDebouncedStatesDataCallback()
  const fetchStates = async () => {
    try {
      const response = await getStates(initialMetaForTable)
      if (response["states"]) {
        const data = response?.states;
        setStates(sortData(data))
      }
      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchCounties = async (stateId) => {
    try {
      const response = await getCounties({ ...initialMetaForTable, state_id: stateId })
      if (response["counties"]) {
        const data = response?.counties;
        setCountiesList(sortData(data))
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchStates()
  }, [])

  useEffect(() => {
    if (currentFilters?.state?.length) {
      const stateIds = currentFilters.state.map(item => item.value);
      fetchCounties(stateIds);
    }
  }, [currentFilters]);

  return (
    <Formik
      initialValues={{
        state: currentFilters.state || [],
        county: currentFilters.county || [],
        health_plan_id: currentFilters.health_plan_id || [],
        expense_request_status: currentFilters.expense_request_status || [],
      }}
      onSubmit={(values, { setSubmitting }) => {
        // const payload = {
        //   ...values,
        //   state: values?.state.map((item) => item?.value)
        // }
        handleSubmittion(values, setSubmitting);
      }}
    >
      {({ values, handleSubmit, setFieldValue, isSubmitting }) => {
        console.log("THIS IS VALUES", values)
        return (
          <div className="question-modal">
            <hr className="custom-modal-line mt-0" />
            <form className="form-main" onSubmit={handleSubmit}>
              <div className="input-flex row">
                <div className="col-sm-12">
                  <AsyncSelect
                    label="State"
                    name="state"
                    options={states.map((item) => ({
                      label: item?.name?.toUpperCase(),
                      value: item?.id
                    }))}
                    selectedValue={values?.state}
                    isMulti
                    handleChange={(selectedOptions) => {
                      setFieldValue(
                        "state",
                        selectedOptions
                      )
                      const stateIds = selectedOptions?.map((opt) => opt.value) || [];
                      setFieldValue("county", "")
                      fetchCounties(stateIds)
                    }}
                    loadOptions={(inputValue) =>
                      new Promise((resolve) =>
                        debounceStatesDataCallBack(
                          inputValue,
                          resolve
                        )
                      )
                    }
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="state"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-12">
                  <AsyncSelect
                    label="County"
                    isMulti
                    options={countiesList.map((item) => ({
                      label: capitalizeName(item?.name),
                      value: item?.id
                    }))}
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedFetchCountiesData(inputValue, values.state?.map((opt) => opt.value), resolve);
                      })
                    }
                    selectedValue={values.county}
                    placeholder="Select county"
                    handleChange={(selected) => {
                      setFieldValue("county", selected);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="county"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-12">
                  <AsyncSelect
                    label="Health Plan"
                    options={healthPlansList.map((el) => ({
                      value: el.id,
                      label: el.name,
                    }))}
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedHealthPlansDataCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={values.health_plan_id}
                    placeholder="Select Health Plan "
                    handleChange={(obj) => {
                      setFieldValue("health_plan_id", obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="health_plan_id"
                      />
                    }
                  />
                </div>
                <div className="col-sm-12">
                  <SelectComponent
                    label=" Expense Request Status"
                    name="expense_request_status"
                    options={expense_request_status}
                    selectedValue={
                      values?.expense_request_status
                        ? expense_request_status.filter((option) =>
                          values?.expense_request_status.includes(option?.value)
                        )
                        : []
                    }
                    isMulti
                    handleChange={(selectedOptions) =>
                      setFieldValue(
                        "expense_request_status",
                        selectedOptions
                          ? selectedOptions.map((option) => option?.value)
                          : []
                      )
                    }
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="expense_request_status"
                      />
                    }
                  />
                </div>
              </div>
              <hr className="custom-modal-line mt-4" />
              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {isSubmitting ? (
                  <span className="primary-btn w-50">
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Filtering...
                  </span>
                ) : (
                  <input
                    className="primary-btn w-50"
                    type="submit"
                    name="submit"
                    value="Apply"
                  />
                )}
              </div>
            </form>
          </div>
        )
      }}
    </Formik>
  );
};

export default HousingExpenseRequestFilter;
